var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnrichment = function SvgEnrichment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00104 0.733398C3.98777 0.733398 0.734375 3.9868 0.734375 8.00007C0.734375 12.0133 3.98777 15.2667 8.00104 15.2667C12.0143 15.2667 15.2677 12.0133 15.2677 8.00007C15.2677 3.9868 12.0143 0.733398 8.00104 0.733398ZM1.93438 8.00007C1.93438 4.64954 4.65051 1.9334 8.00104 1.9334C11.3516 1.9334 14.0677 4.64954 14.0677 8.00007C14.0677 11.3506 11.3516 14.0667 8.00104 14.0667C4.65051 14.0667 1.93438 11.3506 1.93438 8.00007ZM10.3095 11.2942V10.4139H7.20438V8.4102H9.86275V7.54324H7.20438V5.73856H10.2874V4.85391H7.20438H6.89033H6.09414V11.2942H6.89033H7.20438H10.3095Z",
    fill: "#595959"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnrichment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "enrichment.edfb71cf17e26092264069da1ecedb84.svg";